import React from "react";

/**
 * Footer section of the drop-off modal.
 * Shows sum total, deduction total (standard mode only),
 * payment method selector, and the submit button.
 */
const DropOffFooter = ({
  totalAmount,
  totalDeduction,
  isManualEnabled,
  selectedMethod,
  onMethodChange,
  dropOffData,
  onSubmit,
  loading,
  disabled,
}) => {
  const isCorporate = dropOffData?.owner?.roles?.[0] === "corporate";
  const isUnregistered = dropOffData?.owner?.user_type === "unregistered";
  const hasWallet = !!dropOffData?.owner?.account?.account_number;

  /**
   * Determine which payment options to show:
   * - Corporate                → Transfer only (forced, handled in hook)
   * - Unregistered / no wallet → Cash only
   * - Registered with wallet   → Transfer + Cash
   */
  const renderPaymentOptions = () => {
    if (isCorporate) {
      return <option value="transfer">Transfer To Switch Wallet</option>;
    }
    if (isUnregistered || !hasWallet) {
      return <option value="cash">Cash</option>;
    }
    // Registered user with a wallet gets both options
    return (
      <>
        <option value="transfer">Transfer To Switch Wallet</option>
        <option value="cash">Cash</option>
      </>
    );
  };

  return (
    <div>
      <div className="d-flex align-items-center flex-wrap">
        {/* Deductions — only shown in standard (non-manual) mode */}
        {!isManualEnabled && (
          <div className="mb-3 mr-3 total">
            <label className="mb-1 form-label">Deductions</label>
            <input
              type="text"
              className="form-control form-control-lg inputStyle bg-dark text-white"
              placeholder="₦0.00"
              value={`₦${totalDeduction}`}
              disabled
            />
          </div>
        )}

        {/* Sum total */}
        <div className="mb-3 mr-3 total">
          <label className="mb-1 form-label">Sum Total</label>
          <input
            type="text"
            className="form-control form-control-lg inputStyle bg-dark text-white"
            placeholder="₦0.00"
            value={`₦${totalAmount}`}
            disabled
          />
        </div>

        {/* Payment method selector */}
        <div className="mb-3 mr-3 total pt-2">
          <div className="form-group">
            <label htmlFor="paymentMethodSelect">Select Payment Method</label>
            <select
              className="form-control"
              id="paymentMethodSelect"
              value={selectedMethod}
              onChange={(e) => {
                onMethodChange(e.target.value);
                localStorage.setItem("paymentMethod", e.target.value);
              }}
            >
              <option value="">Select</option>
              {renderPaymentOptions()}
            </select>
          </div>
        </div>
      </div>

      {/* Submit button */}
      <div className="mt-1 mb-5 w-btn">
        <button
          type="button"
          className="btn loginBtn btn-sm btn-block"
          onClick={onSubmit}
          disabled={loading || disabled}
        >
          {loading ? "Processing..." : "Initiate Payment"}
        </button>
      </div>
    </div>
  );
};

export default DropOffFooter;
